<div id="state-menu-all-option" class="dropdown-option all-option" role="option" data-name="all">All</div>
{{#each States}}
<div id="state-option-{{id}}" class="dropdown-option" role="option" data-name="{{Name}}">{{Name}}</div>
{{/each}}
